import { render, staticRenderFns } from "./PropertieDetail.vue?vue&type=template&id=6867bda1&scoped=true"
import script from "./PropertieDetail.vue?vue&type=script&lang=js"
export * from "./PropertieDetail.vue?vue&type=script&lang=js"
import style0 from "./PropertieDetail.vue?vue&type=style&index=0&id=6867bda1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867bda1",
  null
  
)

export default component.exports